import React, { memo, useState, useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Form, Button, Input } from 'antd';

// containers
import SelectFieldAxios from 'containers/SelectFieldAxios';
// components
import CustomSelect from 'components/Forms/Fields/CustomSelect';

// global user
import { useChangeChildByID, useGetLocalUser } from 'engine/Contexts/User.context';

// utils
import { DISPENSARY_PROGRAM, ACTIVITY_REASON } from 'utils/helpers/helper.constant';
import { getStatusesList } from 'utils/helpers/helper.generateData';
import { sortByKey, clean } from 'utils/helpers/helper.general';
// hooks
import { useRefState } from 'utils/hooks';

function ReasonForm({
  formData,
  type,
  // actions
  nextStep,
  prevStep,
  result,
  setSelectedStudent,
  // default
  className,
}) {
  const childClassName = classNames('form-absence', className);

  const localUser = useGetLocalUser()();
  const changeChildByID = useChangeChildByID();

  const [isDisabled, setIsDisabled] = useState(false);

  // only for teacher mode
  const [studentParent, studentParentRef, setStudentParent] = useRefState(false);

  const [absenceStatus, setAbsenceStatus] = useState(
    formData?.status || 'pending',
  );
  const initFormData = {

  };
  const [AbsFormReason] = Form.useForm();

  if (localUser?.role == 'teacher') {
    initFormData.status = 'pending';
  }

  /* 
   * Check current form data from parent
   * Set old data to the form
   */
  useEffect(() => {
    if (formData) {
      const hasValFormData = clean(formData);
      AbsFormReason.setFieldsValue({
        status: hasValFormData?.status || 'pending',
        reason: hasValFormData?.reason || null,
        student: hasValFormData?.student?._id || hasValFormData?.student || null
      });
      setAbsenceStatus(hasValFormData?.status || 'pending');
      setIsDisabled(false);

      if (hasValFormData?.student?._id) {
        localUser?.role == 'parent' && (
          changeChildByID(hasValFormData?.student?._id || hasValFormData?.student)
        );
        const contact_person = hasValFormData?.student?.contact_person?._id || hasValFormData?.student?.contact_person;
        const parent = contact_person || hasValFormData?.student?.parents[0]?._id || hasValFormData?.student?.parents[0]
        setStudentParent(parent);
      }
    }
  }, [formData]);

  const onFinish = values => {
    const resultObj = values || {};
    resultObj.parent = studentParentRef?.current || null;
    result(resultObj);
    nextStep !== undefined && nextStep();
    AbsFormReason.resetFields();
  };

  const DEFAULT_REASONS = type=='medical' ? DISPENSARY_PROGRAM : ACTIVITY_REASON;
  const sortBy = 'label';
  const listReasons = DEFAULT_REASONS.map(elem => {
    return {
      key: elem.key,
      label: elem.label,
      title: elem.title || elem.label,
      value: elem.value,
    };
  });
  // sort options
  listReasons.sort(sortByKey(sortBy));

  // Select student for current absence
  let selectStudents = useMemo(() => {
    // initial data for SelectFieldAxios component
    const newElementSelect = {
      label: 'Étudiant',
      name: 'student',
      endponit: `students/list/select`,
      endponitSend: {},
      required: true,
      value: formData?.student?._id || formData?.student || '',
      displayLabel: true,
      type: 'axios-select',
      tagRender: props => (
        <span className="multiple-label-list">{props.label}</span>
      ),
      onSelect: (LabeledValue, option) => {
        setSelectedStudent(option?.item);
        localUser?.role == 'parent' && (
          changeChildByID(option?.item?._id || option?.item)
        );
        const contact_person = option?.item?.contact_person?._id || option?.item?.contact_person;
        const parent = contact_person || option?.item?.parents[0]?._id || option?.item?.parents[0]
        setStudentParent(parent);
      },
      itemCallback: item => {
        return {
          key: item?._id,
          label: `${item?.description?.lastname} ${ item?.description?.firstname }`,
          value: item?._id,
          item: item,
        };
      },
    };

    return (
      <>
        <SelectFieldAxios
          isSearch={true}
          sortBy="label"
          className="axios-select"
          placeholder="Sélectionnez un étudiant"
          tagRender={newElementSelect.tagRender}
          itemCallback={newElementSelect.itemCallback}
          item={newElementSelect}
          onSelect={newElementSelect.onSelect}
          endponit={newElementSelect.endponit}
          endponitSend={newElementSelect.endponitSend}
          /*  getResponse={response => {
            if (response?.data.length > 0) {} 
          }} */
        />
        {studentParentRef?.current && (
          <Form.Item name="parent" hidden={true}
            initialValue={studentParentRef.current}
            rules={[
              {
                required: false,
                message: '',
              },
            ]}
          >
            <Input />
          </Form.Item>
        )}
      </>
    );
  }, [formData, studentParentRef, setStudentParent, setSelectedStudent, localUser]);

  return (
    <div className={childClassName}>
      <Form
        form={AbsFormReason}
        className="form-absence__form"
        name={`form_absence_${type}_reason`}
        initialValues={initFormData}
        onFinish={onFinish}
        onValuesChange={values => {
          setIsDisabled(false);
          values?.status && setAbsenceStatus(values?.status);
        }}
      >
        {localUser?.role == 'teacher' && selectStudents}
      
        {localUser?.role == 'teacher' && (
          <CustomSelect
            className={`accent-label select-status ${absenceStatus}`}
            label={`Status`}
            value={absenceStatus}
            placeholder="Selectionner"
            name={`status`}
            options={getStatusesList(type)}
          />
        )} 

        <CustomSelect
          className="accent-label"
          label={`Motif : ${type == 'medical' ? 'Médicale' : 'Non-Médicale'}`}
          placeholder="Selectionner"
          name={`reason`}
          options={listReasons}
        />

        <div className="absence-actions-wrapper">
          <Button
            className="btn-previous"
            onClick={() => prevStep !== undefined && prevStep()}
          >
            Précédent
          </Button>
          <Button
            className="next-btn"
            form={`form_absence_${type}_reason`}
            htmlType="submit"
            disabled={isDisabled}
          >
            Suivant
          </Button>
        </div>
      </Form>
    </div>
  );
}

ReasonForm.defaultProps = {
  type: 'medical',
};

ReasonForm.propTypes = {
  type: PropTypes.oneOf(['medical', 'no-medical', 'sickness']).isRequired,
  result: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  goToStep: PropTypes.func.isRequired,
};

export default memo(ReasonForm);
